// extracted by mini-css-extract-plugin
export default {"calendarIcon":"DateInput_calendarIcon__H6XHy"};